import React from 'react';
import "./Home.css";

const Home = () => {
    return (
        <div className="home-container">
        <div className="content">
            <h1>My Name is Purnima</h1>
            <h2>Welcome to My Website</h2>
            <p>
                I'm a Computer Science student from Victoria, BC. I'm passionate about software development and love creating projects that solve real-world problems. In my free time, I enjoy hiking, cooking, and exploring new technologies. This website is a place where I share my projects, experiences, and thoughts on technology. Feel free to explore and get in touch if you'd like to connect!
            </p>
        </div>
        </div>
    );
};

export default Home;